import utils from '@utils/utils';
import styles from './index.module.scss';

const EMPTY_BG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/FolderCardEmpty.png';
const FLODER_BG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/floderbg.png';

const ReferFolderCard = (props) => {
    const { item, onClick, className = '' } = props;

    const previewImages = item.previewImages || [];
    const isEmpty = previewImages.length === 0;
    const firstImage = previewImages[0] || '';

    return (
        <div className={`${styles.ReferFolderCard} ${className}`.trim()} onClick={onClick}>
            <div className={styles.ReferFolderCardContent}>
                {isEmpty ? (
                    <div className={styles.emptyBg} style={{ backgroundImage: `url(${EMPTY_BG})` }} />
                ) : (
                    <div className={styles.singleImage}>
                        {firstImage && <img src={utils.getImgThumbnail(firstImage)} alt="" />}
                        <div className={styles.folderOverlay} style={{ backgroundImage: `url(${FLODER_BG})` }} />
                    </div>
                )}
            </div>
            <div className={styles.ResourceName}>
                <span title={item.name}>{item.name}</span>
            </div>
        </div>
    )
}

export default ReferFolderCard;
